<template>
  <div class="fts-form-automation-section">
    <!-- enable as a two-state ledger row (§3.2b: weight, not hue; leftmost = default) -->
    <div class="dm-ledger-rule">
      <div class="dm-ledger-rule-label">
        Form automation — blocks that run when this form is submitted
      </div>
      <div class="dm-ledger-states">
        <span
          class="dm-ledger-state"
          :class="{ 'dm-ledger-state--on': !enabled }"
          @click="enabled && setEnabled(false)"
        >Off</span>
        <span class="dm-ledger-sep">·</span>
        <span
          class="dm-ledger-state"
          :class="{ 'dm-ledger-state--on': enabled }"
          @click="!enabled && setEnabled(true)"
        >On</span>
      </div>
    </div>
    <div class="automation-design-content" v-if="form.automation">
      <fts-automation-designer
        ref="automationDesigner"
        :module-id="moduleId"
        :activity-id="activityId"
        :save-button="saveButton"
        :data="form.automation"
        :is-form="true"
        :form="form"
        @save="$emit('save')"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import FTSAutomationDesigner from "./automation/FTSAutomationDesigner.vue";

/* The FORM automation designer as a modal section (activity designer "Automation" tab). Owns
   the enable state and the Start-node bootstrap that used to live in FTSFormDesigner's footer. */
export default {
  components: {
    "fts-automation-designer": FTSAutomationDesigner
  },
  props: {
    // the activity's work design (formData.design) — automation lives at form.automation
    form: {
      type: Object,
      required: true
    },
    activityId: String,
    saveButton: Boolean
  },
  data: () => ({
    /* stash-don't-delete (same discipline as the behavior ledger): switching Off keeps the
       diagram here until the modal closes, so flipping back On restores it intact */
    stashedAutomation: null
  }),
  computed: {
    moduleId() {
      return this.$store.state.vectorId.toString();
    },
    enabled() {
      return Boolean(this.form && this.form.automation);
    }
  },
  methods: {
    setEnabled(val) {
      if (val) {
        if (this.stashedAutomation) {
          this.$set(this.form, "automation", this.stashedAutomation);
          this.stashedAutomation = null;
          this.$nextTick(() => {
            this.$refs.automationDesigner && this.$refs.automationDesigner.loadDiagram();
          });
        } else {
          this.setupAutomation();
        }
      } else {
        this.stashedAutomation = this.form.automation;
        this.$set(this.form, "automation", null);
      }
    },
    startNodeVariables() {
      return [
        {
          id: "form",
          fieldName: "form",
          name: "Form",
          nodeId: 1,
          type: 7,
          moduleId: this.moduleId,
          activityId: this.activityId
        },
        {
          id: "entry",
          fieldName: "entry",
          name: "Entry",
          nodeId: 1,
          type: 7,
          moduleId: this.moduleId
        },
        {
          id: "initial",
          fieldName: "initial",
          name: "Initial",
          nodeId: 1,
          type: 1
        },
        {
          id: "query",
          fieldName: "query",
          name: "Query",
          nodeId: 1,
          type: 37
        },
        {
          id: "event",
          fieldName: "event",
          name: "Event",
          nodeId: 1,
          type: 37
        },
        {
          id: "interaction",
          fieldName: "interaction",
          name: "Interaction",
          nodeId: 1,
          type: 37
        }
      ];
    },
    setupAutomation() {
      if (!this.form.automation) {
        Vue.set(this.form, "automation", {
          // master plan (2026-08-01): new automation starts on the server-native engine
          serverNative: true,
          testLocusId: null,
          testLocus: null,
          testLocusDetailId: null,
          testLocusDetail: null
        });
        this.form.automation.blocks = {
          1: {
            id: 1,
            name: "start",
            data: {
              id: "start",
              variables: []
            },
            class: "start",
            html: "start",
            typenode: "vue",
            outputs: {
              output_1: {
                connections: []
              }
            },
            inputs: {},
            pos_x: 200,
            pos_y: 50
          }
        };
      }

      this.form.automation.blocks[1].data.variables = this.startNodeVariables();

      let vm = this;
      this.$nextTick(() => {
        vm.$refs.automationDesigner.loadDiagram();
      });
    }
  },
  mounted() {
    if (this.form.automation) {
      this.$set(this.form.automation.blocks[1].data, "variables", this.startNodeVariables());
      this.$refs.automationDesigner.loadDiagram();
    }
  }
};
</script>

<style lang="scss">
.fts-form-automation-section {
  .automation-design-content {
    margin-top: 0.5rem;
  }
}
</style>
